import React from "react";

export default function LicenseExpiredOverlay({ onNavigate, license, customMessage }) {
  const accountId = license?.accountId || license?.accountid || "";
  const planEndDate = license?.planEndDate || license?.plan_end_date || "";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(15, 23, 42, 0.5)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: "24px",
          padding: "36px 32px 30px",
          maxWidth: "520px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 25px 60px -15px rgba(15, 23, 42, 0.35), 0 0 0 1px rgba(239, 68, 68, 0.25)",
          position: "relative",
          animation: "fadeIn 0.25s ease-out",
        }}
      >
        <div
          style={{
            width: "70px",
            height: "70px",
            borderRadius: "20px",
            background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
            border: "2px solid #f87171",
            color: "#dc2626",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "32px",
            boxShadow: "0 8px 22px rgba(220, 38, 38, 0.2)",
            marginBottom: "16px",
          }}
        >
          ⚠️
        </div>

        <div
          style={{
            fontSize: "24px",
            fontWeight: 800,
            color: "#1e293b",
            lineHeight: 1.2,
            marginBottom: "8px",
          }}
        >
          License Expired
        </div>

        <div
          style={{
            fontSize: "15px",
            color: "#64748b",
            lineHeight: 1.5,
            marginBottom: "20px",
          }}
        >
          {customMessage || "Your NetScore Rental Management license has expired. Access to rental features, orders, and configuration is currently paused."}
        </div>

        <div
          style={{
            background: "linear-gradient(180deg, #fff5f5 0%, #fef2f2 100%)",
            border: "1.5px solid #fca5a5",
            borderRadius: "14px",
            padding: "16px 18px",
            marginBottom: "24px",
            textAlign: "left",
            boxShadow: "0 2px 8px rgba(239, 68, 68, 0.06)",
          }}
        >
          <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
            <span style={{ fontSize: "18px", lineHeight: 1.2 }}>📢</span>
            <div style={{ fontSize: "14px", color: "#991b1b", lineHeight: 1.5 }}>
              <strong>Action Required:</strong> Please contact your <strong>License Administrator</strong> or NetScore support to renew your license and reactivate your rental workspace.
            </div>
          </div>
          {(accountId || planEndDate) && (
            <div style={{ marginTop: "12px", paddingTop: "10px", borderTop: "1px dashed #fca5a5", fontSize: "13px", color: "#7f1d1d", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "6px" }}>
              {accountId && <span>Account: <strong>{accountId}</strong></span>}
              {planEndDate && <span>Expired: <strong>{planEndDate}</strong></span>}
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
          <a
            href="mailto:support@netscoretech.com?subject=License%20Renewal%20Request%20-%20NetScore%20Rental%20Management"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              padding: "12px 24px",
              borderRadius: "12px",
              background: "#dc2626",
              color: "#ffffff",
              fontWeight: 700,
              fontSize: "15px",
              textDecoration: "none",
              cursor: "pointer",
              boxShadow: "0 6px 16px rgba(220, 38, 38, 0.28)",
            }}
          >
            Contact Administrator
          </a>
          {onNavigate && (
            <button
              type="button"
              onClick={() => onNavigate("dashboard")}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "12px 20px",
                borderRadius: "12px",
                background: "#f1f5f9",
                border: "1px solid #cbd5e1",
                color: "#334155",
                fontWeight: 600,
                fontSize: "15px",
                cursor: "pointer",
              }}
            >
              Go to Dashboard
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
